{
  "addToFavorites": "Add to favorites",
  "alertCondition": "Alert condition",
  "alertCreateFailed": "Failed to create price alert.",
  "alertCreated": "Price alert created.",
  "alertTargetValue": "Alert target value",
  "allChains": "All Chains",
  "allMarkets": "All",
  "buyToken": "Buy Token",
  "chain": "Chain",
  "change24h": "24H Change",
  "chart": "Chart",
  "coin": "Coin",
  "contract": "Contract",
  "contractCopied": "Contract copied.",
  "createAlert": "Create Alert",
  "exchange": "Exchange",
  "favorite": "Favorite",
  "filteredCoins": "Filtered Coins",
  "gainers": "Gainers",
  "holders": "Holders",
  "hot": "Hot",
  "invalidAlertValue": "Enter a valid positive number.",
  "lastUpdated": "Last updated",
  "liquidity": "Liquidity",
  "live": "LIVE",
  "liveMarketBoard": "● Live Market Board",
  "loading": "Loading...",
  "loadingMarkets": "Loading markets...",
  "losers": "Losers",
  "marketCap": "Market Cap",
  "marketCategories": "Market categories",
  "marketStatus": "Market Status",
  "marketsSubtitle": "Approved coins, verified contracts, live charts, liquidity and volume.",
  "marketsTitle": "EXALT Markets",
  "noApprovedCoins": "No approved coins found.",
  "noContractFound": "No contract found.",
  "percentChange": "Moves by %",
  "percentPlaceholder": "e.g. 5",
  "price": "Price",
  "priceAbove": "Price rises above",
  "priceAlerts": "Price Alerts",
  "priceBelow": "Price falls below",
  "pricePlaceholder": "e.g. 50000",
  "refresh": "Refresh",
  "removeFromFavorites": "Remove from favorites",
  "searchCoin": "Search coin, symbol or contract...",
  "staleMarketBoard": "⚠ Prices may be stale",
  "status": "Status",
  "submittingAlert": "Creating...",
  "symbol": "Symbol",
  "telegram": "Telegram",
  "topGainer": "Top Gainer",
  "topLoser": "Top Loser",
  "totalListedCoins": "Total Listed Coins",
  "trending": "Trending",
  "volume": "Volume",
  "volume24h": "24H Volume",
  "website": "Website"
}